import { Link } from "react-router-dom";

export default function EnrollCancelled() {
  return (
    <div className="mx-auto max-w-2xl p-8 text-center">
      <h1 className="text-2xl font-bold">Checkout cancelled</h1>
      <p className="mt-3 text-gray-600">
        No charge was made. Your seat was not reserved — you can try again any time.
      </p>
      <Link
        to="/"
        className="mt-6 inline-block rounded bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-700"
      >
        Back to cohorts
      </Link>
    </div>
  );
}
